import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parseNumericInput } from 'app/modules/utilities/shared/decimal-input';

/** Rejects zero, negative or non-numeric values; an empty value is left to `Validators.required`. */
export function positiveNumberValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = parseNumericInput(value);
  if (parsed !== null && parsed > 0) {
    return null;
  }
  return { notPositive: true };
}

/**
 * Cross-field check ensuring the minimum pressure is not above the maximum.
 *
 * @remarks
 * Equal pressures are valid: PWM systems usually run at a constant boom
 * pressure and let the duty cycle modulate the flow. Missing or non-positive
 * pressures are skipped here so the field validators (`required`,
 * `notPositive`) report them instead of a misleading range error.
 */
export function pressureRangeValidator(
  group: AbstractControl,
): ValidationErrors | null {
  const pressureMin = parseNumericInput(group.get('pressureMin')?.value);
  const pressureMax = parseNumericInput(group.get('pressureMax')?.value);
  if (
    pressureMin === null ||
    pressureMax === null ||
    pressureMin <= 0 ||
    pressureMax <= 0
  ) {
    return null;
  }
  if (pressureMin <= pressureMax) {
    return null;
  }
  return { pressureRange: true };
}
